import { Injectable } from "@angular/core";
import { ApiGenericAction } from "../../api-actions";
import { genericApiAction } from "../../onsip-api-action-new";

@Injectable({ providedIn: "root" })
export class SignupValidateDomainService {
  async signupValidateDomain(domain: string): Promise<void> {
    await genericApiAction({
      Action: ApiGenericAction.SignupValidateDomain,
      Domain: domain
    });
  }
}
